module.exports = __webpack_public_path__ + "static/media/icons8-twitter.9a35ed7f.svg";